import React from "react";

const Header = ({ toggleSidebar, isSidebarOpen, isMobile }) => {
    return (
        <header className="global-header">
            {isMobile && !isSidebarOpen && (
                <button className="menu-button" onClick={toggleSidebar}>☰</button>
            )}
            <h4 className="company-name">Shatrunjay Financial Advisors</h4>
        </header>
    );
};

export default Header;
